import { useState, useEffect } from "react";
import Popup from "../other/Popup";
import { can } from "../../utils/permissions";
import { normalizeNumberInputValue, parseNullableInteger } from "./userFieldUtils";
import { getCastellerFullName } from "../../utils/castellerName";

function EditUser(props) {
    const { user, closed, setClosed, socket, userInfo, userId } = props;

    const [nom, setNom] = useState('');
    const [cognom, setCognom] = useState('');
    const [segonCognom, setSegonCognom] = useState('');
    const [mote, setMote] = useState('');
    const [altura, setAltura] = useState('');
    const [alturaMans, setAlturaMans] = useState('');
    const [tecnicaRole, setTecnicaRole] = useState(0);
    const [juntaRole, setJuntaRole] = useState(0);
    const [hidden, setHidden] = useState(false);
    const [canalla, setCanalla] = useState(false);
    const [music, setMusic] = useState(false);
    const [lesionat, setLesionat] = useState(false);
    const [casteller, setCasteller] = useState(false);
    const [soci, setSoci] = useState(false);
    const [novell, setNovell] = useState(false);

    useEffect(() => {
        if (!closed && user) {
            setNom(user.nom);
            setCognom(user['primer-cognom']);
            setSegonCognom(user['segon-cognom']);
            setMote(user.mote);
            setAltura(normalizeNumberInputValue(user.altura));
            setAlturaMans(normalizeNumberInputValue(user.altura_mans));
            setTecnicaRole(user['es_tecnica']);
            setJuntaRole(user['es_junta']);
            setHidden(user['hidden'] === 1);
            setCanalla(user['canalla'] === 1);
            setMusic(user['music'] === 1);
            setLesionat(user['lesionat'] === 1);
            setCasteller(user['casteller'] === 1);
            setSoci(user['soci'] === 1);
            setNovell(user['novell'] === 1);
        } else {
            setNom('');
            setCognom('');
            setSegonCognom('');
            setMote('');
            setAltura('');
            setAlturaMans('');
            setTecnicaRole(0);
            setJuntaRole(0);
            setHidden(false);
            setCanalla(false);
            setMusic(false);
            setLesionat(false);
            setCasteller(false);
            setSoci(false);
            setNovell(false);
        }
        
    }, [user, closed]);

    const updateUser = () => {
        const responses = {
            'id': user.id,
            'nom': nom,
            'primer-cognom': cognom,
            'segon-cognom': segonCognom,
            'mote': mote,
            'altura': parseNullableInteger(altura),
            'altura_mans': parseNullableInteger(alturaMans),
            'tecnica': parseInt(tecnicaRole),
            'junta': parseInt(juntaRole),
            'hidden': hidden ? 1 : 0,
            'canalla': canalla ? 1 : 0,
            'music': music ? 1 : 0,
            'lesionat': lesionat ? 1 : 0,
            'casteller': casteller ? 1 : 0,
            'novell': novell ? 1 : 0,
            '_actorId': userId || userInfo?.id, // Fallback for socket.userId
        };

        socket.emit('.edit_user', responses);
        socket.emit('.request_users');
        setClosed(true);
    };

    const force_logout_user = user => {
        const msg = `Vols tancar la sessió de ${getCastellerFullName(user, 'aquest usuari')} a tots els dispositius?`;
        if (window.confirm(msg)) {
            socket.emit('.force_logout', { user_id: user.id });
            socket.emit('.request_users');
        }
    };


    if (!closed) {
        return (
            <Popup closed={closed} setClosed={setClosed}>
                <h2>Editar casteller</h2>
                <div className="user-info">
                    <div className="title">Nom</div>
                    <div><input type="text" value={nom} onChange={e => setNom(e.target.value)} /></div>
                    <div className="title">1r cognom</div>
                    <div><input type="text" value={cognom} onChange={e => setCognom(e.target.value)} /></div>
                    <div className="title">2n cognom</div>
                    <div><input type="text" value={segonCognom} onChange={e => setSegonCognom(e.target.value)} /></div>
                    <div className="title">Mote</div>
                    <div><input type="text" value={mote} onChange={e => setMote(e.target.value)} /></div>
                    <div className="title">Altura</div>
                    <div><input type="number" value={altura} onChange={e => setAltura(e.target.value)} onWheel={(e) => e.target.blur()} /></div>
                    <div className="title">Altura mans</div>
                    <div><input type="number" value={alturaMans} onChange={e => setAlturaMans(e.target.value)} onWheel={(e) => e.target.blur()} /></div>
                    <div className="title">És tècnica</div>
                    <div>
                        { can(props.userInfo, 'ASSIGN_HEAD_TECNICA') ? <label><input onChange={() => setTecnicaRole(2)} name="tecnica" type="radio" checked={parseInt(tecnicaRole) === 2} /> Cap de tècnica</label> : null }
                        { can(props.userInfo, 'ASSIGN_TECNICA') ? <label><input onChange={() => setTecnicaRole(1)} name="tecnica" type="radio" checked={parseInt(tecnicaRole) === 1} /> Tècnica</label> : null }
                        <label><input onChange={() => setTecnicaRole(0)} name="tecnica" type="radio" checked={parseInt(tecnicaRole) === 0} /> No tècnica</label>
                    </div>
                    <div className="title">És junta</div>
                    <div>
                        { can(props.userInfo, 'ASSIGN_HEAD_JUNTA') ? <label><input onChange={() => setJuntaRole(2)} name="junta" type="radio" checked={parseInt(juntaRole) === 2} /> Cap de junta</label> : null }
                        { can(props.userInfo, 'ASSIGN_JUNTA') ? <label><input onChange={() => setJuntaRole(1)} name="junta" type="radio" checked={parseInt(juntaRole) === 1} /> Junta</label> : null }
                        <label><input onChange={() => setJuntaRole(0)} name="junta" type="radio" checked={parseInt(juntaRole) === 0} /> No junta</label>
                    </div>
                    <div className="title">Amagar casteller</div>
                    <div><label>Amagar casteller? <input type="checkbox" checked={hidden} onChange={e => setHidden(e.target.checked)} /></label></div>
                    <div className="title">És canalla</div>
                    <div><label>És canalla? <input type="checkbox" checked={canalla} onChange={e => setCanalla(e.target.checked)} /></label></div>
                    <div className="title">Músic</div>
                    <div><label>Músic? <input type="checkbox" checked={music} onChange={e => setMusic(e.target.checked)} /></label></div>
                    <div className="title">Lesionat</div>
                    <div><label>Lesionat? <input type="checkbox" checked={lesionat} onChange={e => setLesionat(e.target.checked)} /></label></div>
                    <div className="title">És novell</div>
                    <div><label>És novell? <input type="checkbox" checked={novell} onChange={e => setNovell(e.target.checked)} /></label></div>
                    <div className="title">És casteller</div>
                    <div><label>És casteller? <input type="checkbox" checked={casteller} onChange={e => setCasteller(e.target.checked)} /></label></div>
                    <div className="title">És soci</div>
                    <div>
                        <label>
                            <input 
                                type="checkbox" 
                                checked={soci} 
                                disabled={true}
                                style={{ opacity: 0.6 }}
                            />
                            És soci (automàtic segons quotes pagades)
                        </label>
                        <div style={{ fontSize: '0.8em', color: '#666', marginTop: '4px' }}>
                            Aquest camp s'actualitza automàticament segons si té totes les quotes pagades
                        </div>
                    </div>
                </div>
                <div className="save-buttons">
                    <button onClick={() => updateUser()}>Guardar</button>
                    <a onClick={() => setClosed(true)} href='#'>Cancel·lar</a>
                </div>

                <div className="edit-button">
                    { can(userInfo, 'MANAGE_USER_SESSIONS') ? (
                        <button style={{ backgroundColor: 'rgba(255,0,0,0.4)', marginRight: 8 }} onClick={() => force_logout_user(user)}>🚪 Tancar sessió a tots els dispositius</button>
                    ) : null }
                </div>
            </Popup>
        );
    }
}

export default EditUser;
